import React, { useState } from 'react';
import { Clock, Calendar, ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * مكون جدول البرامج - يعرض الجدول اليومي والأسبوعي للبرامج
 */
const ProgramSchedule = () => {
  const [viewMode, setViewMode] = useState('daily'); // 'daily' or 'weekly'
  const [selectedDay, setSelectedDay] = useState(0); // 0 = اليوم

  // Weekly schedule data
  const weekSchedule = [
    {
      day: 'السبت',
      programs: [
        { id: 1, titleAr: 'بودكاست: يجمعنا وطن', time: '06:00 - 08:00', presenter: 'فريق الإذاعة', description: 'يركز على إنجازات الجامعة والقوات المسلحة ومواضيع الأمن والأمان وحماة الوطن', image: require('../assest/New folder/20231018152136397XT.jpg') },
        { id: 2, titleAr: ' بودكاست: للوطن كلمة', time: '08:00 - 12:00', presenter: 'فريق الإذاعة', description: 'البث المباشر احتفالاً بالعيد الوطني 54', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg'), isLive: true },
        { id: 3, titleAr: 'برنامج: التكامل والموائمة ', time: '12:00 - 14:00', presenter: 'فريق الإذاعة', description: 'يركز على الجانب العلمي والأكاديمي وتخصصاته، إضافة للجانب التدريبي والعسكري في الجامعة', image: require('../assest/New folder/38808175-9242-4e8f-bd2f-6913942e667c.jpg') },
        { id: 4, titleAr: 'بودكاست:  شقائق الرجال', time: '14:00 - 16:00', presenter: 'فريق الإذاعة', description: 'التعرف عن قرب على نماذج الناجحة من المرشحين ومن مخرجات جامعة زايد العسكرية', image: require('../assest/New folder/39d95edc-c56f-4389-b893-bd8dc4f53f50.jpg') },
        { id: 5, titleAr: 'روح الوطنية ', time: '16:00 - 18:00', presenter: 'فريق الإذاعة', description: 'يركز على أهم الاستراتيجيات والسياسات والمبادرات في القطاعات المختلفة', image: require('../assest/New folder/4567.jpg') },
        { id: 6, titleAr: 'فخر ورفعة', time: '18:00 - 19:00', presenter: 'فريق الإذاعة', description: 'فاصل يركز على إرث زايد الإنساني والوطني والممتد حتى اليوم', image: require('../assest/New folder/4f30ee4b-7b2d-4796-802f-93fe5a5e98c4.jpg') },
      ]
    },
    {
      day: 'الأحد',
      programs: [
        { id: 7, titleAr: 'بودكاست: يجمعنا وطن', time: '06:00 - 08:00', presenter: 'فريق الإذاعة', description: 'يركز على إنجازات الجامعة والقوات المسلحة ومواضيع الأمن والأمان وحماة الوطن', image: require('../assest/New folder/671cf452-9d76-470b-9d2e-270c77ec66ba.jpg') },
        { id: 8, titleAr: 'بودكاست: للوطن كلمة ', time: '08:00 - 12:00', presenter: 'فريق الإذاعة', description: 'البث المباشر احتفالاً بالعيد الوطني 54', image: require('../assest/New folder/7637d68f-34ce-4888-bbbb-610c6435fa70.jpg'), isLive: true },
        { id: 9, titleAr: 'برنامج: التكامل والموائمة', time: '12:00 - 14:00', presenter: 'فريق الإذاعة', description: 'يركز على الجانب العلمي والأكاديمي وتخصصاته، إضافة للجانب التدريبي والعسكري في الجامعة', image: require('../assest/New folder/IMG_2050 (1).jpg') },
        { id: 10, titleAr: 'بودكاست: شقائق الرجال', time: '14:00 - 16:00', presenter: 'فريق الإذاعة', description: 'التعرف عن قرب على نماذج الناجحة من المرشحين ومن مخرجات جامعة زايد العسكرية', image: require('../assest/New folder/Screenshot 2025-10-28 144106.png') },
        { id: 11, titleAr: 'روح الوطنية ', time: '16:00 - 18:00', presenter: 'فريق الإذاعة', description: 'يركز على أهم الاستراتيجيات والسياسات والمبادرات في القطاعات المختلفة', image: require('../assest/New folder/Screenshot 2025-10-28 144328.png') },
        { id: 12, titleAr: 'فخر ورفعة', time: '18:00 - 19:00', presenter: 'فريق الإذاعة', description: 'فاصل تحفيزي يومي يرفع من روح الوطنية ويعزز المواطنة الصالحة', image: require('../assest/New folder/20231018152136397XT.jpg') },
      ]
    },
    {
      day: 'الإثنين',
      programs: [
        { id: 13, titleAr: 'بودكاست: يجمعنا وطن', time: '06:00 - 08:00', presenter: 'فريق الإذاعة', description: 'يركز على إنجازات الجامعة والقوات المسلحة ومواضيع الأمن والأمان وحماة الوطن', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 14, titleAr: 'بودكاست: للوطن كلمة ', time: '08:00 - 12:00', presenter: 'فريق الإذاعة', description: 'البث المباشر احتفالاً بالعيد الوطني 54', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg'), isLive: true },
        { id: 15, titleAr: 'برنامج: التكامل والموائمة', time: '12:00 - 14:00', presenter: 'فريق الإذاعة', description: 'يركز على الجانب العلمي والأكاديمي وتخصصاته، إضافة للجانب التدريبي والعسكري في الجامعة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 16, titleAr: 'بودكاست: شقائق الرجال', time: '14:00 - 16:00', presenter: 'فريق الإذاعة', description: 'التعرف عن قرب على نماذج الناجحة من المرشحين ومن مخرجات جامعة زايد العسكرية', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 17, titleAr: 'روح الوطنية  ', time: '16:00 - 18:00', presenter: 'فريق الإذاعة', description: 'يركز على أهم الاستراتيجيات والسياسات والمبادرات في القطاعات المختلفة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 18, titleAr: 'فخر ورفعة ', time: '18:00 - 19:00', presenter: 'فريق الإذاعة', description: 'مشاركة الجامعة المجتمع بأي إنجاز تحققه الدولة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
      ]
    },
    {
      day: 'الثلاثاء',
      programs: [
        { id: 19, titleAr: 'بودكاست: يجمعنا وطن', time: '06:00 - 08:00', presenter: 'فريق الإذاعة', description: 'يركز على إنجازات الجامعة والقوات المسلحة ومواضيع الأمن والأمان وحماة الوطن', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 20, titleAr: 'بودكاست: للوطن كلمة ', time: '08:00 - 12:00', presenter: 'فريق الإذاعة', description: 'البث المباشر احتفالاً بالعيد الوطني 54', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg'), isLive: true },
        { id: 21, titleAr: 'برنامج: التكامل والموائمة', time: '12:00 - 14:00', presenter: 'فريق الإذاعة', description: 'يركز على الجانب العلمي والأكاديمي وتخصصاته، إضافة للجانب التدريبي والعسكري في الجامعة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 22, titleAr: 'بودكاست: شقائق الرجال', time: '14:00 - 16:00', presenter: 'فريق الإذاعة', description: 'التعرف عن قرب على نماذج الناجحة من المرشحين ومن مخرجات جامعة زايد العسكرية', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 23, titleAr: 'روح الوطنية ', time: '16:00 - 18:00', presenter: 'فريق الإذاعة', description: 'يركز على أهم الاستراتيجيات والسياسات والمبادرات في القطاعات المختلفة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 24, titleAr: 'فخر ورفعة', time: '18:00 - 19:00', presenter: 'فريق الإذاعة', description: 'تصاريح سريعة لعدد من الإداريين والأكاديميين وحتى الطلبة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
      ]
    },
    {
      day: 'الأربعاء',
      programs: [
        { id: 25, titleAr: 'بودكاست: يجمعنا وطن', time: '06:00 - 08:00', presenter: 'فريق الإذاعة', description: 'يركز على إنجازات الجامعة والقوات المسلحة ومواضيع الأمن والأمان وحماة الوطن', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 26, titleAr: 'بودكاست: للوطن كلمة ', time: '08:00 - 12:00', presenter: 'فريق الإذاعة', description: 'البث المباشر احتفالاً بالعيد الوطني 54', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg'), isLive: true },
        { id: 27, titleAr: 'برنامج: التكامل والموائمة', time: '12:00 - 14:00', presenter: 'فريق الإذاعة', description: 'يركز على الجانب العلمي والأكاديمي وتخصصاته، إضافة للجانب التدريبي والعسكري في الجامعة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 28, titleAr: 'بودكاست: شقائق الرجال', time: '14:00 - 16:00', presenter: 'فريق الإذاعة', description: 'التعرف عن قرب على نماذج الناجحة من المرشحين ومن مخرجات جامعة زايد العسكرية', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 29, titleAr: 'فخر و رفعة', time: '16:00 - 18:00', presenter: 'فريق الإذاعة', description: 'يركز على أهم الاستراتيجيات والسياسات والمبادرات في القطاعات المختلفة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 30, titleAr: 'روح الوطنية', time: '18:00 - 19:00', presenter: 'فريق الإذاعة', description: 'فاصل يركز على إرث زايد الإنساني والوطني والممتد حتى اليوم', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
      ]
    },
    {
      day: 'الخميس',
      programs: [
        { id: 31, titleAr: 'بودكاست: يجمعنا وطن', time: '06:00 - 08:00', presenter: 'فريق الإذاعة', description: 'يركز على إنجازات الجامعة والقوات المسلحة ومواضيع الأمن والأمان وحماة الوطن', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 32, titleAr: 'بودكاست: للوطن كلمة ', time: '08:00 - 12:00', presenter: 'فريق الإذاعة', description: 'البث المباشر احتفالاً بالعيد الوطني 54', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg'), isLive: true },
        { id: 33, titleAr: 'برنامج: التكامل والموائمة', time: '12:00 - 14:00', presenter: 'فريق الإذاعة', description: 'يركز على الجانب العلمي والأكاديمي وتخصصاته، إضافة للجانب التدريبي والعسكري في الجامعة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 34, titleAr: 'بودكاست: شقائق الرجال', time: '14:00 - 16:00', presenter: 'فريق الإذاعة', description: 'التعرف عن قرب على نماذج الناجحة من المرشحين ومن مخرجات جامعة زايد العسكرية', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 35, titleAr: ':  فخر ورفعة', time: '16:00 - 18:00', presenter: 'فريق الإذاعة', description: 'يركز على أهم الاستراتيجيات والسياسات والمبادرات في القطاعات المختلفة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 36, titleAr: 'روح الوطنية', time: '18:00 - 19:00', presenter: 'فريق الإذاعة', description: 'فاصل تحفيزي يومي يرفع من روح الوطنية ويعزز المواطنة الصالحة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
      ]
    },
    {
      day: 'الجمعة',
      programs: [
        { id: 37, titleAr: 'بودكاست: يجمعنا وطن', time: '06:00 - 08:00', presenter: 'فريق الإذاعة', description: 'يركز على إنجازات الجامعة والقوات المسلحة ومواضيع الأمن والأمان وحماة الوطن', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 38, titleAr: 'بودكاست: للوطن كلمة ', time: '08:00 - 12:00', presenter: 'فريق الإذاعة', description: 'البث المباشر احتفالاً بالعيد الوطني 54', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg'), isLive: true },
        { id: 39, titleAr: 'برنامج: التكامل والموائمة', time: '12:00 - 14:00', presenter: 'فريق الإذاعة', description: 'يركز على الجانب العلمي والأكاديمي وتخصصاته، إضافة للجانب التدريبي والعسكري في الجامعة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 40, titleAr: 'بودكاست: شقائق الرجال', time: '14:00 - 16:00', presenter: 'فريق الإذاعة', description: 'التعرف عن قرب على نماذج الناجحة من المرشحين ومن مخرجات جامعة زايد العسكرية', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 41, titleAr: 'روح الوطنية   ', time: '16:00 - 18:00', presenter: 'فريق الإذاعة', description: 'يركز على أهم الاستراتيجيات والسياسات والمبادرات في القطاعات المختلفة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
        { id: 42, titleAr: 'فخر ورفعة', time: '18:00 - 19:00', presenter: 'فريق الإذاعة', description: 'تصاريح سريعة لعدد من الإداريين والأكاديميين وحتى الطلبة', image: require('../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg') },
      ]
    }
  ];

  const days = ['اليوم', 'السبت', 'الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة'];

  const currentDayPrograms = selectedDay === 0 ? weekSchedule[0].programs : weekSchedule[selectedDay - 1].programs;

  const ProgramCard = ({ program }) => (
    <div className="bg-gradient-to-br from-gold/40 via-white to-gold/40 backdrop-blur-sm rounded-xl shadow-lg overflow-hidden border-2 border-gold/50 hover:shadow-2xl hover:scale-102 hover:border-gold transition-all duration-300 group">
      <div className="flex gap-3 p-3 md:p-4">
        {/* Program Image */}
        <div className="flex-shrink-0">
          <div className={`relative w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden shadow-md border-2 ${program.isLive ? 'border-red-500 animate-pulse' : 'border-gold/30'} group-hover:border-gold transition-all`}>
            <img
              src={program.image}
              alt={program.titleAr}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
            />
            {program.isLive && (
              <div className="absolute top-0 right-0 bg-gradient-to-r from-gold to-gold-dark text-white text-[10px] px-1.5 py-0.5 rounded-bl font-bold animate-pulse">
                مباشر
              </div>
            )}
          </div>
        </div>

        {/* Program Details */}
        <div className="flex-1 min-w-0">
          <h4 className="text-primary font-bold text-base md:text-lg mb-1 truncate group-hover:text-gold transition-colors">
            {program.titleAr}
          </h4>
          
          <div className="flex flex-wrap gap-2 text-xs">
            <div className="flex items-center gap-1 bg-gradient-to-r from-gold to-gold-light text-white px-2 py-1 rounded-md font-bold shadow-sm">
              <Clock className="w-3 h-3" />
              <span>{program.time}</span>
            </div>
            
            <div className="flex items-center gap-1 bg-gradient-to-r from-lightBeige to-beige text-primary px-2 py-1 rounded-md font-medium shadow-sm">
              <span>{program.presenter}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="py-12 md:py-16 lg:py-20 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-3 md:mb-4">
            جدول البرامج
          </h2>
          <p className="text-gray-600 text-lg md:text-xl">
            تابع برامجك المفضلة على مدار الأسبوع
          </p>
        </div>

        {/* View Mode Toggle */}
        <div className="flex justify-center mb-6 md:mb-8">
          <div className="bg-gradient-to-br from-gold/50 via-white to-gold/50 backdrop-blur-sm rounded-xl shadow-lg p-1 inline-flex border-2 border-gold/60">
            <button
              onClick={() => setViewMode('daily')}
              className={`px-6 md:px-8 py-2 md:py-3 rounded-lg font-bold text-sm md:text-base transition-all duration-300 flex items-center gap-2 ${
                viewMode === 'daily'
                  ? 'bg-gradient-to-r from-gold to-lightBeige text-primary shadow-lg scale-105'
                  : 'text-gray-600 hover:text-primary'
              }`}
            >
              <Calendar className="w-4 h-4 md:w-5 md:h-5" />
              <span>عرض يومي</span>
            </button>
            <button
              onClick={() => setViewMode('weekly')}
              className={`px-6 md:px-8 py-2 md:py-3 rounded-lg font-bold text-sm md:text-base transition-all duration-300 flex items-center gap-2 ${
                viewMode === 'weekly'
                  ? 'bg-gradient-to-r from-gold to-lightBeige text-primary shadow-lg scale-105'
                  : 'text-gray-600 hover:text-primary'
              }`}
            >
              <Calendar className="w-4 h-4 md:w-5 md:h-5" />
              <span>عرض أسبوعي</span>
            </button>
          </div>
        </div>

        {/* Daily View */}
        {viewMode === 'daily' && (
          <div>
            {/* Day Selector */}
            <div className="flex items-center justify-center gap-2 mb-6 md:mb-8 overflow-x-auto pb-2">
              <button
                onClick={() => setSelectedDay(Math.max(0, selectedDay - 1))}
                disabled={selectedDay === 0}
                className="p-2 bg-gradient-to-br from-gold/40 via-white to-gold/40 rounded-lg shadow-md hover:shadow-lg transition-all disabled:opacity-30 disabled:cursor-not-allowed border border-gold/40"
              >
                <ChevronRight className="w-5 h-5 text-primary" />
              </button>

              <div className="flex gap-2">
                {days.map((day, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedDay(index)}
                    className={`px-4 md:px-6 py-2 md:py-3 rounded-lg font-bold text-sm md:text-base transition-all duration-300 whitespace-nowrap ${
                      selectedDay === index
                        ? 'bg-gradient-to-br from-gold via-gold-light to-gold text-white shadow-xl scale-110 border-2 border-gold'
                        : 'bg-gradient-to-br from-gold/40 via-white to-gold/40 text-gray-700 hover:text-primary shadow-md border border-gold/40'
                    }`}
                  >
                    {day}
                  </button>
                ))}
              </div>

              <button
                onClick={() => setSelectedDay(Math.min(7, selectedDay + 1))}
                disabled={selectedDay === 7}
                className="p-2 bg-gradient-to-br from-gold/40 via-white to-gold/40 rounded-lg shadow-md hover:shadow-lg transition-all disabled:opacity-30 disabled:cursor-not-allowed border border-gold/40"
              >
                <ChevronLeft className="w-5 h-5 text-primary" />
              </button>
            </div>

            {/* Programs Grid */}
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {currentDayPrograms.map(program => (
                <ProgramCard key={program.id} program={program} />
              ))}
            </div>
          </div>
        )}

        {/* Weekly View */}
        {viewMode === 'weekly' && (
          <div className="space-y-6 md:space-y-8">
            {weekSchedule.map((daySchedule, dayIndex) => (
              <div key={dayIndex} className="bg-gradient-to-br from-gold/40 via-white to-gold/40 backdrop-blur-sm rounded-2xl shadow-xl overflow-hidden border-2 border-gold/60">
                {/* Day Header */}
                <div className="bg-gradient-to-r from-gold via-gold-light to-gold p-4 md:p-5">
                  <h3 className="text-white font-bold text-xl md:text-2xl text-center">
                    {daySchedule.day}
                  </h3>
                </div>

                {/* Programs Grid */}
                <div className="p-4 md:p-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {daySchedule.programs.map(program => (
                    <ProgramCard key={program.id} program={program} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgramSchedule;
